export default __webpack_public_path__ + "static/media/Ajustes (Real Size).3ab2e18c.svg";